import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQAccordion = ({ items = [], testId = "faq-accordion" }) => {
  if (!items.length) return null;
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testId}>
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          className="border-b border-stone-line"
          data-testid={`faq-item-${i}`}
        >
          <AccordionTrigger className="py-5 text-left font-serif text-lg md:text-xl font-medium text-charcoal hover:no-underline hover:text-gold-dark">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-base leading-relaxed font-light text-slatey">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default FAQAccordion;
